import New from "csi/table/New";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";

/** @property {string} FORMULATED_MATERIAL - the node type used in the controller */
const FORMULATED_MATERIAL = "FormulatedMaterial";

const NewImpactAnalysis = declare(New, {
	/**
	 * @override
	 * Allow controller to add parameters to popup view
	 */
	onCreatePopupParams(params) {
		params.productLabel = FORMULATED_MATERIAL;
	},

	/**
	 * @override
	 * FormulatedMaterial is marked to be taken care on the server side
	 */
	toWriterRequest(fd: FormData): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("Purpose", xml.ATTR_ENUM, "ECPurpose:ImpactAnalysis");
		return call;
	},
});

export = NewImpactAnalysis;